import { faCog, faEnvelope, faLock, faMoneyBill, faPhotoFilm, faUsersGear } from '@fortawesome/free-solid-svg-icons'
import { NavItem } from '../../core/interfaces/nav/nav-item.interface'
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
import { Permissions } from '../../core/permissions'
import { Features } from '../../core/features'

export const navItems: NavItem[] = [
    {
        name: 'Leads',
        url: '/leads',
        faIcon: faUsersGear,
        statProperty: 'leads',
        unauthorizedBehavior: 'disabled',
        requiresSubscription: true,
    },
    {
        name: 'Messages',
        faIcon: faEnvelope,
        url: '/messages',
        statProperty: 'tickets',
        permissions: [Permissions.Emails.View],
        unauthorizedBehavior: 'disabled',
        requiresSubscription: true,
    },
    {
        name: 'Boiler Widget',
        url: '/boiler-quote-manager',
        faIcon: faQuestionCircle,
        statProperty: 'surequote',
        feature: Features.BoilerWidget,
        unauthorizedBehavior: 'disabled',
        requiresSubscription: true,
    },
    // {
    //     name: 'AC Widget',
    //     url: '/surequotes',
    //     attributes: { disabled: true },
    //     faIcon: faQuestionCircle,
    //     badge: {
    //         color: 'info',
    //         text: 'NEW',
    //     },
    // },
    // {
    //     name: 'ASHP Widget',
    //     url: '/surequotes',
    //     attributes: { disabled: true },
    //     faIcon: faQuestionCircle,
    //     badge: {
    //         color: 'info',
    //         text: 'NEW',
    //     },
    // },
    {
        name: 'Quote Wizard',
        url: '/quote-wizard',
        faIcon: faQuestionCircle,
        statProperty: 'quoteWizardQuotes',
        feature: Features.QuoteWizard,
        badge: {
            color: 'success',
            text: '0',
        },
        unauthorizedBehavior: 'disabled',
        requiresSubscription: true,
    },

    // {
    //     name: 'Messaging',
    //     faIcon: faEnvelope,
    //     url: '/messaging',
    // },
    // {
    //     name: 'Tickets',
    //     faIcon: faEnvelope,
    //     url: '/tickets',
    //     statProperty: 'tickets',
    // },

    {
        name: 'Media Library',
        url: '/media-library',
        faIcon: faPhotoFilm,
        statProperty: 'mediaLibrary',
        unauthorizedBehavior: 'disabled',
        requiresSubscription: true,
    },
    {
        title: true,
        name: 'Admin',
        requiresAdmin: true,
    },
    {
        name: 'Admin',
        faIcon: faCog,
        requiresAdmin: true,
        url: '/admin',
        unauthorizedBehavior: 'hide',
        requiresSubscription: true,
    },
    {
        name: 'Subscription',
        url: '/subscription',
        faIcon: faMoneyBill,
        requiresAdmin: true,
    },
    {
        title: true,
        name: 'Support',
        requiresSupport: true,
    },
    {
        name: 'Support',
        url: '/support',
        faIcon: faLock,
        requiresSupport: true,
    },
    {
        name: 'Billing',
        url: '/billing',
        faIcon: faLock,
        requiresSupport: true,
    },
    {
        name: 'Widget Quotes',
        faIcon: faLock,
        requiresSupport: true,
        children: [
            {
                name: 'Products',
                url: '/support/widget-quotes',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Manufacturers',
                url: '/support/widget-quotes/manufacturers',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Background Images',
                url: '/support/widget-quotes/background-images',
                icon: 'nav-icon-bullet',
            },
        ],
    },

    // {
    //     name: 'Dashboard',
    //     url: '/dashboard',
    //     faIcon: faDashboard,
    //     badge: {
    //         color: 'info',
    //         text: 'NEW',
    //     },
    // },
    // {
    //     title: true,
    //     name: 'Theme',
    // },
    // {
    //     name: 'Colors',
    //     url: '/theme/colors',
    //     faIcon: faCode,
    // },
    // {
    //     name: 'Typography',
    //     url: '/theme/typography',
    //     linkProps: { fragment: 'headings' },
    //     faIcon: faPencil,
    // },
    // {
    //     name: 'Components',
    //     title: true,
    // },
    // {
    //     name: 'Base',
    //     url: '/base',
    //     faIcon: faPuzzlePiece,
    //     children: [
    //         {
    //             name: 'Accordion',
    //             url: '/base/accordion',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Breadcrumbs',
    //             url: '/base/breadcrumbs',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Cards',
    //             url: '/base/cards',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Carousel',
    //             url: '/base/carousel',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Collapse',
    //             url: '/base/collapse',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'List Group',
    //             url: '/base/list-group',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Navs & Tabs',
    //             url: '/base/navs',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Pagination',
    //             url: '/base/pagination',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Placeholder',
    //             url: '/base/placeholder',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Popovers',
    //             url: '/base/popovers',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Progress',
    //             url: '/base/progress',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Spinners',
    //             url: '/base/spinners',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Tables',
    //             url: '/base/tables',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Tabs',
    //             url: '/base/tabs',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Tooltips',
    //             url: '/base/tooltips',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     name: 'Buttons',
    //     url: '/buttons',
    //     faIcon: faMobileButton,
    //     children: [
    //         {
    //             name: 'Buttons',
    //             url: '/buttons/buttons',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Button groups',
    //             url: '/buttons/button-groups',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Dropdowns',
    //             url: '/buttons/dropdowns',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     name: 'Forms',
    //     url: '/forms',
    //     faIcon: faNoteSticky,
    //     children: [
    //         {
    //             name: 'Form Control',
    //             url: '/forms/form-control',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Select',
    //             url: '/forms/select',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Checks & Radios',
    //             url: '/forms/checks-radios',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Range',
    //             url: '/forms/range',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Input Group',
    //             url: '/forms/input-group',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Floating Labels',
    //             url: '/forms/floating-labels',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Layout',
    //             url: '/forms/layout',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Validation',
    //             url: '/forms/validation',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     name: 'Charts',
    //     faIcon: faChartPie,
    //     url: '/charts',
    // },
    // {
    //     name: 'Icons',
    //     faIcon: faStar,
    //     url: '/icons',
    //     children: [
    //         {
    //             name: 'CoreUI Free',
    //             url: '/icons/coreui-icons',
    //             icon: 'nav-icon-bullet',
    //             badge: {
    //                 color: 'success',
    //                 text: 'FREE',
    //             },
    //         },
    //         {
    //             name: 'CoreUI Flags',
    //             url: '/icons/flags',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'CoreUI Brands',
    //             url: '/icons/brands',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     name: 'Notifications',
    //     url: '/notifications',
    //     faIcon: faBell,
    //     children: [
    //         {
    //             name: 'Alerts',
    //             url: '/notifications/alerts',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Badges',
    //             url: '/notifications/badges',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Modal',
    //             url: '/notifications/modal',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Toast',
    //             url: '/notifications/toasts',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     name: 'Widgets',
    //     url: '/widgets',
    //     faIcon: faCalculator,
    //     badge: {
    //         color: 'info',
    //         text: 'NEW',
    //     },
    // },
    // {
    //     title: true,
    //     name: 'Extras',
    // },
    // {
    //     name: 'Pages',
    //     url: '/login',
    //     faIcon: faStar,
    //     children: [
    //         {
    //             name: 'Login',
    //             url: '/login',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Register',
    //             url: '/register',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Error 404',
    //             url: '/404',
    //             icon: 'nav-icon-bullet',
    //         },
    //         {
    //             name: 'Error 500',
    //             url: '/500',
    //             icon: 'nav-icon-bullet',
    //         },
    //     ],
    // },
    // {
    //     title: true,
    //     name: 'Links',
    //     class: 'mt-auto',
    // },
    // {
    //     name: 'Docs',
    //     url: 'https://coreui.io/angular/docs/',
    //     iconComponent: { name: 'cil-description' },
    //     faIcon: faFileWord,
    //     attributes: { target: '_blank' },
    // },
]
